// @flow
import { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import DeepLink, {
  deeplinkForPlatform,
} from 'app/common/react/components/growth/unauth/lib/DeepLink';
import withUnauthSeoExperiments, {
  ExperimentsPropType,
  type UnauthSeoExperiments,
} from 'app/common/lib/react/withUnauthSeoExperiments';

type Props = {
  androidDeeplink: string,
  iOSDeeplink: string,
  seoUnauthExperiments: UnauthSeoExperiments,
};

class DeeplinkAutoRedirect extends Component<Props> {
  componentDidMount() {
    this.setupDeeplinkAutoRedirect();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      (nextProps.androidDeeplink && nextProps.androidDeeplink !== this.props.androidDeeplink) ||
      (nextProps.iOSDeeplink && nextProps.iOSDeeplink !== this.props.iOSDeeplink)
    ) {
      this.setupDeeplinkAutoRedirect();
    }
  }

  // This can only be called when the component has been mounted
  setupDeeplinkAutoRedirect() {
    if (__SERVER__) {
      return;
    }

    const { androidDeeplink, iOSDeeplink } = this.props;
    const { isAuthenticated, unauthId, userAgent } = this.context;

    const deeplink = new DeepLink(userAgent.raw, userAgent.platform);

    const customSchemeDeeplink = deeplinkForPlatform(
      userAgent.platform,
      androidDeeplink,
      iOSDeeplink,
    );
    if (!customSchemeDeeplink) {
      return;
    }

    deeplink.attemptAutoRedirectToApp(
      unauthId,
      document.referrer,
      isAuthenticated,
      userAgent,
      customSchemeDeeplink,
    );
  }

  render() {
    return null;
  }
}

DeeplinkAutoRedirect.contextTypes = {
  isAuthenticated: PropTypes.bool.isRequired,
  unauthId: PropTypes.string.isRequired,
  userAgent: PropTypes.shape({
    canUseNativeApp: PropTypes.bool.isRequired,
    isTablet: PropTypes.bool.isRequired,
    platform: PropTypes.string.isRequired,
    platformVersion: PropTypes.arrayOf(PropTypes.number),
    raw: PropTypes.string.isRequired,
  }),
};

DeeplinkAutoRedirect.propTypes = {
  androidDeeplink: PropTypes.string,
  iOSDeeplink: PropTypes.string,
  seoUnauthExperiments: ExperimentsPropType,
};

export default compose(withUnauthSeoExperiments)(DeeplinkAutoRedirect);
